module.exports = {
  "Gattaran_V1__YaIb": "En línea",
  "Gattaran_V1__xaNO": "Tasa de cancelación",
  "FoodB_Commision_Type_of_EIWZ": "Tipo de tienda",
  "FoodB_0926__pZyK": "No hay promociones en curso",
  "FoodB_Show_ID_Card_BrxO": "Cédula de identidad",
  "FoodB_Analysis_Yesterday_nearly_aBCt": "Ayer",
  "FoodB_030_zOTR_tsWu": "Mi zona",
  "FoodC_intostore_Store_Coupon_kHwh": "Cupones de la tienda",
  "FoodB_NewStore_Status_HphC": "Estado",
  "FoodB_Commision_Add_MPEf": "Agregar",
  "FoodB_list_Store_Phone_tSWo": "Número de teléfono de la tienda",
  "FoodB_202204_Number_of_yYUn": "Pedidos con calificación negativa",
  "FoodB_030_fqBt_uzDV": "Faltan permisos: {{City}}. Solicita un permiso en Gattaran.",
  "FoodB_tagging_You_chose_OMGB": "Decidiste invalidar este socio potencial por el siguiente motivo: \"La tienda no existe\". Para hacerlo, debes cargar una foto.",
  "FoodB_Show_Savings_uvSS": "Cuenta de ahorros",
  "FoodB_0_Please_upload_ziBz": "Carga una captura de pantalla del historial de llamadas",
  "FoodB_phrase__NpWx": "Sólo promos finalizadas en los últimos {{number}} meses",
  "FoodB_0322_gUpY_CIHG": "No hay tiendas que coincidan con los filtros",
  "FoodD_payout_Company_Registration_zoVW": "Cédula Jurídica",
  "FoodB_list_Apply_for_RxQn": "Solicitar firma",
  "FoodB_audit_Distance_between_BRSw": "Distancia entre la tienda anterior y la nueva",
  "FoodB_field_Is_you_uNye": "¿Sujeto al pago del IVA nacional?",
  "FoodB_0905__dSOH": "Diagnóstico de la tienda",
  "FoodB_optimization_Label_nzNw": "Etiqueta",
  "FoodB_leads_Artificial_labcategory_UNzu": "Categoría de etiqueta manual",
  "FoodB_Launch_DR_Military_Rxvi": "Cédula Militar",
  "FoodB_P0_cNyW_HkyE": "Cambios en pedidos completados",
  "FoodB_Show_Store_Direct_GuJM": "Contrato firmado mediante B-App",
  "FoodB_leads_The_relationship_jkYA": "Hora ideal para contactar",
  "FoodB_list_Store_ID_GNUR": "No. de identificación de la tienda",
  "FoodOpB_Management_Appeals_foxk": "Solicitar revisión",
  "FoodB_optimization__bdZL": "La imagen debe tener un formato JPG o PNG, pesar menos de 5 MB y ser de al menos 200×200 píxeles.",
  "FoodB_20230410_YNjt_xAWA": "DiDi Top",
  "FoodB_Launch_DR_Foreigner_gXpW": "Cédula Extranjera",
  "FoodB_system_offline_revV": "Fuera de línea",
  "FoodB_210811_No_tax_QkcN": "Falta un documento fiscal",
  "FoodC_sales_Confirmation_mTGd": "Entendido",
  "FoodB_0926__bEjZ": "No hay promociones iniciadas",
  "FoodB_v1_Sources_of_DsXR": "Fuente de información",
  "FoodB_CL_Individuals_VUHt": "Persona física",
  "FoodB_list_Setting_Up_YlBy": "set_open_duration",
  "FoodB_b_Source_of_qGPd": "Origen del evento",
  "FoodB_list_Brand_Name_pGTc": "Nombre de la marca",
  "FoodB_0_Please_upload_roTo": "Carga una captura de pantalla del historial de correo electrónico",
  "FoodB_V2_Satisfied_with_YFEM": "Satisfecha con la situación actual",
  "FoodD_Name_April_UHuR": "Abr",
  "FoodB_phrase__PWcd": "No hay promos finalizadas para ver",
  "Gattaran_V1__hUDQ": "Servicio",
  "FoodB_0_Please_upload_BZIQ": "Carga una captura de pantalla del historial de chat",
  "FoodB_Show_Current_NJqK": "Cuenta corriente",
  "FoodB_CL_power_of_KgHH": "Contrato de mandato",
  "FoodB_1__gcdX": "Datos del evento",
  "FoodB_list_KP_Phone_qQCQ": "Teléfono del representante de la tienda",
  "FoodD_payout_Account_Type_YmVW": "Tipo de cuenta",
  "FoodB_I_Home_OrRo": "Inicio",
  "FoodB_tagging_You_chose_lWSH": "Decidiste invalidar este socio potencial por el siguiente motivo: \"No es una tienda de venta minorista\". Para hacerlo, debes estar a menos de {{distance}} de la tienda. Verifícalo e inténtalo de nuevo.",
  "FoodC_replace_Clear_Filter_iwTY": "Borrar filtros",
  "FoodB_030_SQUQ_YDRS": "No mis tiendas",
  "FoodB_0905__qppX": "{{number}} pedidos menos que antes",
  "FoodB_V2_dLkl_pbiF": "Para realizar esta acción, actualiza la aplicación a la versión más reciente.",
  "FoodD_Name_September_Ezci": "Sep",
  "FoodD_Name_December_Ykas": "Dic",
  "FoodB_V2_Illegal_companies_pXwb": "No registrada legalmente",
  "FoodB_0622_Increase_store_kZfr": "Agregar comparación de tiendas",
  "FoodOpB_CRM_Party_B_BCQp": "Número de identificación de la empresa",
  "FoodB_0_Mail_SUKZ": "Correo electrónico",
  "FoodD_Name_January_lhYr": "Ene",
  "FoodB_audit_Store_Information_ryuV": "Se realizó una revisión de la información modificada de la tienda",
  "FoodD_Name_May_zYiz": "May",
  "FoodOpB_CRM_Taxpayer_Address_ptqR": "Dirección del  contribuyente (Local)",
  "FoodB_list_KP_Name_GQRs": "Nombre del representante de la tienda",
  "FoodD_Name_June_sECU": "Jun",
  "FoodC_c_Completed_djPp": "Finalizado",
  "FoodB_Launch_Illegal_import_jlOS": "Entrada no válida",
  "FoodD_Name_November_BcWL": "Nov",
  "FoodB_list_Recently_launched_IWDa": "Última vez conectada",
  "FoodB_Show_Taxpayer_Document_eadz": "Tipo de documento tributario (local)",
  "FoodB_new1_Name_similarity_gepH": "Similitud del nombre",
  "FoodB_Wordings_MYHl_FXti": "Selecciona un motivo",
  "FoodD_supplement_Rules_RYAa": "Reglas",
  "FoodD_Incentive_In_progress_GNvs": "En curso",
  "FoodB_tagging_You_chose_DSiT": "Decidiste invalidar este socio potencial por el siguiente motivo: \"Operaciones detenidas\". Para hacerlo, debes cargar una foto o el número de contacto del representante de la tienda.",
  "FoodB_1__IhgO": "Actualizado el {{time}}",
  "FoodB_2_Visit_Records_LiJy": "Resumen de visitas",
  "FoodB_diagnosis_Items_qQOR": "artículo(s)",
  "FoodB_optimization_Contract_No_GvBj": "Núm. de ident. del contrato",
  "FoodB_0919__YKYU": "Sin promociones",
  "FoodB_Analysis_Nearly_7_wumh": "Últimos {{day}} días",
  "FoodB_2_During_the_QHhU": "Periodo de registro",
  "FoodB_202204_Order_eJXF": "Pedidos",
  "FoodB_field_No_need_hToz": "Opcional",
  "FoodB_2__YqWB": "Motivo del rechazo",
  "FoodB_switch_yJQj_DSir": "Participando en promociones 100% financiadas",
  "FoodB_0919__RZJo": "Pedidos completados",
  "FoodB_SMS__promotion_EKZy": "Promoción de entrega sin costo",
  "FoodB_orders_Select_Store_gtmG": "Seleccionar tiendas",
  "FoodB_Wordings_iyFv_fDmW": "Comentarios adicionales",
  "FoodB_audit_Suspected_duplicate_ntLx": "Posible tienda duplicada",
  "FoodB_store_Order_Coupon_zpSY": "Cupón de reembolso de pedido",
  "FoodB_0905__zFVs": "Peso total",
  "FoodB_audit_Review_process_vGtV": "proceso de revisión. ¿Estás seguro de que quieres continuar?",
  "FoodB_Show_Taxpayer_Document_TFeg": "Tipo de documento tributario (nacional)",
  "FoodB_2_Call_visit_NGFu": "Teléfono",
  "FoodB_I_Cancelled_orders_XeVk": "Pedidos cancelados",
  "FoodB_1__GxZN": "Últimos 30 días",
  "FoodB_0_WhatsApp_dmMD": "WhatsApp",
  "FoodD_Name_October_WGkU": "Oct",
  "FoodD_Name_March_cqIc": "Mar",
  "FoodB_optimization_Stimulate_contact_xSSH": "Método de contacto preferido",
  "FoodB_Launch_DR_ID_AnVk": "Cédula Dominicana",
  "FoodB_CL_Vista_Account_QcOm": "Cuenta Vista",
  "FoodB_0707_High_prices_fBsL": "Más altos",
  "FoodB_Show_Tax_payment_xfxh": "Forma de pago de impuestos (Nacional)",
  "FoodB_0921__isZD": "Tasa de artículos calificados",
  "FoodB_0919__mVqa": "Demoras en la entrega",
  "FoodB_optimization_Buy_gifts_daUI": "Compra X, llévate Y gratis",
  "FoodB_I_onwf_oaQH": "Ventas",
  "Gattaran_V1__ccGl": "Últimos 30 días",
  "FoodB_Part1_Store_Name_jrHD": "Nombre del restaurante",
  "FoodC_cash_WQNI_uYzC": "Agregar",
  "FoodB_2_Store_XkLQ": "Tienda",
  "FoodB_0919__CONM": "Artículos no disponibles",
  "FoodB_0622_Select_up_QXDl": "Selecciona hasta 2 tiendas",
  "FoodC_revision_Less_meal_pHwq": "Pedido incompleto",
  "FoodB_0_Please_upload_dcPG": "Carga una captura de pantalla del historial de mensajes de texto",
  "FoodB_system_Competition_NFPY": "Competidor",
  "FoodB_Show_Subject_Information_RFOj": "Información del Representante Legal/Propietario",
  "FoodB_tagging_You_chose_aZCG": "Decidiste invalidar este socio potencial por el siguiente motivo: \"Operaciones detenidas\". Para hacerlo, debes estar a menos de {{distance}} de la tienda. Verifícalo e inténtalo de nuevo.",
  "FoodB_CL_Add_any_egRn": "Es aceptable cualquiera de los siguientes tres documentos:\nPoder del Representante Legal\nCertificado de Comercio de Registro de Santiago (o ciudad respectiva)\nCertificado de Estatuto Actualizado",
  "FoodB_Show_Company_Registration_VcVV": "Cédula Jurídica",
  "FoodB_resivion_Feedback_to_QmQU": "Repórtalo a tu supervisor para que la modifique",
  "FoodB_management_Untied_tYEF": "Desvincular",
  "FoodB_0926__Jfhv": "No hay promociones con este estado",
  "FoodB_0920__QnBO": "Requisitos no cumplidos",
  "FoodB_resivion_Skip_qpSD": "Omitir",
  "FoodOpB_Management_You_can_aDLi": "Para crear la tienda nueva de todos modos, haz clic en “solicitar revisión”. Ten en cuenta que la revisión puede tomar hasta 2 días.",
  "FoodB_0907__jtsj": "No hay datos del diagnóstico",
  "FoodOpB_CRM_Card_holder_NfIL": "Ingresa el número de identificación del beneficiario",
  "FoodB_audit_Similarity_check_cQEP": "Evaluación de similitud",
  "FoodOpB_CRM_Taxpayer_full_fzhk": "Nombre completo del contribuyente (Nacional)",
  "FoodB_0622_The_statistical_NUCJ": "Los datos se calculan con base en T+1 y se organizan de acuerdo al volumen de ventas de los artículos en los últimos 30 días",
  "FoodB_0830__wEQD": "Pedidos completados en este mes",
  "FoodB_CL_Simple_company_JBRG": "Sociedad de sistema simplificado",
  "FoodB_Show_Foreign_DIMEX_LKxF": "DIMEX",
  "FoodB_I_UlHM_KKLT": "Pedidos",
  "FoodB_0921__iLXg": "Cantidad",
  "FoodB_Show_Aliens_Residence_creU": "Cédula de Residencia",
  "FoodB_0905__pNYF": "Los pedidos se superponen. La suma no refleja el total de pedidos completados cada día.",
  "FoodB_0622_Store_management_ztNB": "Operaciones de la tienda",
  "FoodB_0919__etPs": "Múltiples promociones",
  "FoodB_0623_Store_GZFE": "Tienda",
  "Gattaran_V1__zewR": "Menú",
  "FoodOpB_Management_High_similarity_lnFn": "Ya existe una tienda similar",
  "FoodB_Launch_DR_Passport_JChW": "Pasaporte",
  "FoodB_2__CkLu": "La misma ciudad",
  "FoodB_field_Do_you_mhOz": "¿Sujeto al pago del IVA local?",
  "FoodB_0905__yxOa": "Sin cambios",
  "FoodB_CL_Letter_of_EmKs": "Foto del Contrato de Mandato",
  "FoodB_202207_Default_BQmA": "Predeterminado",
  "FoodB_0113_ELbg_zfBg": "Ver info. sobre el asesor de la tienda aquí",
  "FoodB_resivion_Inaccurate_information_dmRA": "¿Hay alguna información incorrecta?",
  "FoodB_Analysis_Old_people_fwCy": "Usuarios recurrentes",
  "FoodB_0905__wwdP": "Peso de subartículo",
  "FoodB_0820__bVDh": "Alta prioridad",
  "FoodB_field_Needs_IbzB": "Obligatorio",
  "FoodB_0905__ccXH": "Periodo del diagnóstico",
  "FoodC_improve__ByLg": "Diferente a lo esperado",
  "FoodB_V2_DQvR_Redp": "Usa la función para compartir en la app de BD.",
  "FoodB_0905__Uuug": "Reglas del diagnóstico",
  "FoodB_CL_Traditional_companies_cQhK": "Sociedad de sistema tradicional",
  "soda-b-homepage-i18n---首位必须是1，必须输入11位": "El primer dígito debe ser 1 y se deben ingresar 11 dígitos.",
  "FoodB_0905__vMsv": "{{number}} pedidos más que antes",
  "FoodB_I_QuSz_HsAZ": "Descuento de promo %",
  "FoodOpB_CRM_Taxpayer_Tax_xOmZ": "N° del  contribuyente (Local)",
  "FoodB_IV_Tips_DFOG": "Alerta",
  "FoodB_audit_The_information_jxLV": "La información que enviaste no cumple con los requisitos",
  "FoodB_optimizing_Duplicate_Store_aBYS": "Número de identificación de restaurante duplicado",
  "FoodD_Name_August_cjQS": "Ago",
  "FoodB_0_SMS_yOMB": "Mensajes de texto",
  "FoodD_Name_February_bMVM": "Feb",
  "FoodB_V2_No_bank_plEI": "Faltan los datos bancarios",
  "FoodB_list_Name_of_dxYm": "Nombre del representante de ventas",
  "FoodB_Show_Final_Tax_XQQi": "Definitivo",
  "FoodB_V2_No_store_ahBo": "Falta RFC (Registro Federal de Contribuyentes) *only mx",
  "FoodB_0623_Indicators_auar": "KPI",
  "FoodB_audit_The_strings_NPFx": "Hacer clic en confirmar iniciará el proceso de revisión \"{{strings}}\". No se puede solicitar la firma del contrato hasta completada la revisión. ¿Deseas continuar?",
  "FoodB_tagging_You_have_ssrJ": "Decidiste invalidar este socio potencial por el siguiente motivo: \"No es una tienda de venta minorista\". Para hacerlo, debes cargar una foto o el número de contacto del representante de la tienda.",
  "FoodC_improve__ovBF": "Porciones pequeñas",
  "Gattaran_V1__ZtqD": "Ver tutorial de promociones",
  "FoodOpB_CRM_Type_of_fbmW": "Tipo de identificación del beneficiario",
  "FoodB_audit_New_and_yYux": "Diferencia entre el nombre anterior de la tienda y el nuevo",
  "FoodB_V2_Failure_to_sQaD": "No cumple con los requisitos",
  "FoodB_Show_Tax_payment_Dbuz": "Forma de pago de impuestos (Local)",
  "FoodD_AccountInfoCollection_Got_it_QvNt": "Entendido",
  "FoodB_0622_Contrast_jVys": "Comparar",
  "FoodB_Show_Special_Tax_Eidl": "NITE (Número de Identificación Tributaria Especial)",
  "Gattaran_resivion_More_KTYU": "Más",
  "FoodOpB_CRM_Taxpayer_full_tMpR": "Nombre completo del contribuyente (Local)",
  "FoodB_0707_Lifted_off_tnXl": "No disponible",
  "FoodB_leads_KP_Phone_hCUe": "Teléfono 2 del representante del restaurante",
  "FoodB_Launch_DR_Temporary_BQFH": "Permiso residencia temporal",
  "FoodB_0830__BIGT": "Visitas en este mes",
  "FoodB_Wordings_DKwT_wbfI": "Indica por qué elegiste esta opción. Tus comentarios son valiosos y nos ayudan a mejorar.",
  "FoodB_new1_Similarity_ItET": "Similitud",
  "FoodB_time_No_permission_Xxyy": "Sin permisos",
  "FoodB_V2_iZpC_KKcK": "Compartir reporte de diagnóstico con la tienda",
  "FoodB_0113_ZcCF_NbjE": "Puedes agregar un plan de visita aquí",
  "FoodB_supplement_No_data_jUGB": "Sin datos",
  "FoodB_0905__uatF": "Mayor que {{number_or_rate}} tiendas cercanas",
  "FoodB_Show_Special_residence_ezfV": "Permiso Especial de Permanencia",
  "FoodB_audit_Review_Opportunity_ZQHk": "Revisión de la información básica del socio potencial editada",
  "FoodB_0921__kEaD": "Subsidio%",
  "FoodB_CL_RUT_roUA": "RUT",
  "FoodB_Analysis_New_customers_vYDl": "Usuarios nuevos",
  "FoodB_audit_Click_OK_Zfsf": "Si das en confirmar, se activará el",
  "FoodB_optimization_Full_reduction_NlOa": "Gasta X, Ahorra Y",
  "FoodB_optimization_Special_Meal_YtqD": "Artículos en promoción",
  "FoodB_2_Online_visit_OLuR": "Presencial",
  "FoodB_0327_ZGTe_zcKH": "Pulsa aquí para cambiar de ciudad",
  "FoodB_resivion_Overdue_visit_jTHW": "Visitas vencidas",
  "FoodB_0905__kaPI": "Calificación del diagnóstico",
  "FoodOpB_CRM_Taxpayer_Address_EBwy": "Dirección del contribuyente (Nacional)",
  "Gattaran_V1__WcTv": "Tasa de artículos calificados",
  "FoodD_Name_July_RJXL": "Jul",
  "FoodB_0919__flip": "Artículos disponibles",
  "FoodB_0622_Sales_KRCg": "Volumen de ventas",
  "FoodB_audit_Audit_process_asoS": "proceso de revisión. No podrás solicitar una firma hasta que se complete este proceso. ¿Estás seguro de que quieres continuar?",
  "FoodB_tagging_You_chose_tIKm": "Decidiste invalidar este socio potencial por el siguiente motivo: \"La tienda no existe\". Para hacerlo, debes estar a menos de {{distance}} de la tienda. Verifícalo e inténtalo de nuevo.",
  "Gattaran_V1__SttS": "Promociones",
  "FoodB_V2_No_legal_QONX": "Falta la identificación del representante legal",
  "FoodB_2__FNaI": "La misma zona objetivo"
}